var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubefillable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15080_236213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0455 7.26303C12.2167 6.28574 8.67578 4.44922 8.67578 4.44922L13.3968 7.62234C13.3972 7.62234 12.5368 8.09932 14.0455 7.26303Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02215 14.4535C5.22366 14.3835 3.92629 14.3206 3.12884 14.1563C2.58932 14.0472 2.12048 13.8048 1.77671 13.4533C1.51102 13.1872 1.29972 12.7813 1.13579 12.218C0.995175 11.7488 0.940409 11.3584 0.86233 10.4048C0.742806 8.25267 0.714312 6.49311 0.86233 4.52707C0.984444 3.44137 1.04365 2.15251 1.85479 1.40058C2.23778 1.04867 2.68331 0.822202 3.18361 0.728582C3.96514 0.580194 7.29479 0.462891 10.7417 0.462891C14.1809 0.462891 17.518 0.580194 18.3002 0.728582C18.9252 0.845885 19.5114 1.19743 19.8555 1.65073C20.5956 2.81488 20.6086 4.26249 20.6837 5.39482C20.7148 5.93435 20.7148 8.99793 20.6837 9.53746C20.5668 11.327 20.4728 11.9601 20.2071 12.6166C20.0428 13.031 19.9025 13.2497 19.6598 13.4921C19.2791 13.8651 18.7937 14.1132 18.2684 14.2033C14.9813 14.4505 12.1901 14.5042 9.02215 14.4535ZM14.0558 7.2628C12.2271 6.28552 10.476 5.37928 8.68615 4.44122V10.0533C10.5697 9.02939 12.5553 8.09133 14.0636 7.25503L14.0558 7.2628Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15080_236213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7455,
    height: 14.4317,
    fill: "inherit",
    transform: "translate(0.625 0.302734)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubefillable);
export default __webpack_public_path__ + "static/media/youtubefillable.02fec20265717d8c4033cde2a9b18248.svg";
export { ForwardRef as ReactComponent };